import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import UserAddressForm from "./UserAddressForm";

const UserAddressAdd = () => {
    return (
        <Fragment>
            <UserAddressForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default UserAddressAdd;